import { computed as t } from "vue";
const Y = ({
  unlinkPanels: u,
  leftDate: a,
  rightDate: r
}) => {
  const o = () => {
    a.value = a.value.subtract(10, "year"), u.value || (r.value = r.value.subtract(10, "year"));
  }, l = () => {
    u.value || (a.value = a.value.add(10, "year")), r.value = r.value.add(10, "year");
  }, v = () => {
    a.value = a.value.add(10, "year");
  }, n = () => {
    r.value = r.value.subtract(10, "year");
  }, c = t(() => {
    const e = Math.floor(a.value.year() / 10) * 10;
    return `${e}-${e + 9}`;
  }), s = t(() => {
    const e = Math.floor(r.value.year() / 10) * 10;
    return `${e}-${e + 9}`;
  }), d = t(() => Math.floor(a.value.year() / 10) * 10 + 9), y = t(() => Math.floor(r.value.year() / 10) * 10);
  return {
    leftPrevYear: o,
    rightNextYear: l,
    leftNextYear: v,
    rightPrevYear: n,
    leftLabel: c,
    rightLabel: s,
    leftYear: d,
    rightYear: y
  };
};
export {
  Y as useYearRangeHeader
};
